import React, { createContext, useContext, useState } from 'react';
export var initialValues = {
    isModalOpen: false,
    open: (function () { }),
    close: function () { },
    modalProps: null
};
export var ProfileEditModalContext = createContext(initialValues);
export var ProfileEditModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(null), modalProps = _c[0], setModalProps = _c[1];
    var open = function (modalProps) {
        setModalProps(modalProps || null);
        setIsModalOpen(true);
    };
    var close = function () {
        setIsModalOpen(false);
        setModalProps(null);
    };
    return (React.createElement(ProfileEditModalContext.Provider, { value: { isModalOpen: isModalOpen, open: open, close: close, modalProps: modalProps } }, children));
};
export var useProfileEditModal = function () { return useContext(ProfileEditModalContext); };
